import { render, staticRenderFns } from "./clientdashboard-register.vue?vue&type=template&id=78efbfe2&"
import script from "./clientdashboard-register.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports